import SummaryHttpTransport from './transports/SummaryHttpTransport';

const summaryProviderInstance = new SummaryHttpTransport({ apiBase: window.$config.analyticsBase });

export default summaryProviderInstance;
